import React from 'react';
import { TypedMemo } from '../../common/types';
import { useDeviceId, useUserTokenDecoded } from '../../../redux/slices/appInfo/hooks';
import { appInformation } from '../../../utils/appInformation/appInformation';
import { useWorkspaces } from '../../workspaces/useWorkspaces';
import { SupportHelpCard } from './support/SupportHelpCard';
import { SupportMessageCard } from './support/SupportMessageCard';
import { SupportDetailsCard } from './support/SupportDetailsCard';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Settings tabs; each part uses its own slice of it */
import cards from './settingsCards.module.scss';
import styles from './support/support.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Settings → Support (design settings-redesign d1). */
const SupportTabComponent: React.FC = () => {
  const deviceId = useDeviceId();
  // The session user. The licence email is the owner's email for a team member.
  const userEmail = useUserTokenDecoded()?.email ?? '';
  const { active } = useWorkspaces();
  const appVersion = `Web ${appInformation.version}`;

  return (
    <div className={cards.pane}>
      <SupportHelpCard />
      <div className={styles.columns}>
        <SupportMessageCard userEmail={userEmail} deviceId={deviceId} />
        <SupportDetailsCard
          userEmail={userEmail}
          workspace={active?.name ?? null}
          appVersion={appVersion}
          deviceId={deviceId}
        />
      </div>
    </div>
  );
};

export const SupportTab = TypedMemo(SupportTabComponent);
